"use client";

import Image from "next/image";
import Link from "next/link";

const API_URL = process.env.NEXT_PUBLIC_API_URI ?? "";
const resolveImg = (src?: string | null) =>
  !src ? "/defaults/banner.jpg" : src.startsWith("http") || src.startsWith("/") ? src : `${API_URL}/${src.replace(/^\/+/, "")}`;

export default function ListPropertyCTA({
  locale,
  isAr,
  image,
}: {
  locale: string;
  isAr: boolean;
  /** Banner image managed from the dashboard (القسم الرئيسي). */
  image?: string | null;
}) {
  const t = (a: string, e: string) => (isAr ? a : e);

  return (
    <section className="py-16 px-6 container mx-auto">
      <div className="relative rounded-[40px] overflow-hidden py-24 text-center">
        <Image
          src={resolveImg(image)}
          alt=""
          fill
          unoptimized
          className="object-cover"
        />
        {/* Light scrim (same in day / night) — enough for the white text, the photo stays clear */}
        <div className="absolute inset-0 bg-gradient-to-t from-shade/75 via-shade/45 to-shade/30" />
        <div className="relative z-10 px-6">
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white mb-6 drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)]">
            {t("هل تملك وحدة؟ اعرضها معنا", "Own a unit? List it with us")}
          </h2>
          <p className="text-white/90 text-lg mb-10 max-w-2xl mx-auto drop-shadow-[0_1px_8px_rgba(0,0,0,0.5)]">
            {t(
              "انضم إلينا وخلّي وحدتك مصدر دخل لك معنا",
              "Join us and turn your unit into a source of income.",
            )}
          </p>
          <Link
            href={`/${locale}/list-property`}
            className="inline-block bg-clay-600 text-white px-12 py-4 rounded-full font-bold text-lg shadow-2xl hover:bg-clay-700 transition-all hover:scale-105"
          >
            {t("ابدأ التأجير الآن", "Start hosting")}
          </Link>
        </div>
      </div>
    </section>
  );
}
